import WidgetModule from "@eisinc/Overrides/Widgets/Common/RecentWishLists";

export * from "@eisinc/Overrides/Widgets/Common/RecentWishLists";

export default WidgetModule;
